<kendo-dialog-titlebar class="gerar-produtos-titlebar" (close)="feche()">
  <h4 class="modal-title">
    <i class="fas fa-cube mr-2"></i>Gerar produtos a partir de insumos
  </h4>
</kendo-dialog-titlebar>

<div class="modal-body">
  <p class="instrucao-modal">
    Selecione os insumos e preencha as informações dos produtos que serão gerados a partir deles,
    como nome, código no PDV e preço.
  </p>

  <div class="row mb-3">
    <div class="col-md-6">
      <label>Grupo de insumos</label>
      <kendo-combobox class="form-control"
                      [data]="grupos"
                      textField="nome"
                      valueField="id"
                      [valuePrimitive]="false"
                      [allowCustom]="false"
                      [disabled]="gerando"
                      [(ngModel)]="grupoSelecionado"
                      (valueChange)="selecionouGrupo($event)">
      </kendo-combobox>
    </div>
    <div class="col-md-6">
      <label>Categoria dos produtos</label>
      <input kendoTextBox class="form-control" maxlength="160"
             name="categoriaProduto"
             [disabled]="gerando"
             [(ngModel)]="categoria"
             placeholder="Nome da categoria">
      <small class="text-muted">Se já existir uma categoria com esse nome, ela será reutilizada.</small>
    </div>
  </div>

  <div class="resumo-geracao">
    <div class="resumo-card resumo-card--selecionados">
      <span class="resumo-icone"><i class="fas fa-check"></i></span>
      <span>
        <small>Selecionados</small>
        <b>{{quantidadeSelecionada()}} de {{linhas.length}}</b>
      </span>
    </div>
    <div class="resumo-card resumo-card--pendentes">
      <span class="resumo-icone"><i class="fas fa-exclamation"></i></span>
      <span>
        <small>Pendentes de preenchimento</small>
        <b>{{quantidadePendente()}}</b>
      </span>
    </div>
    <div class="resumo-card resumo-card--prontos">
      <span class="resumo-icone"><i class="fas fa-check"></i></span>
      <span>
        <small>Prontos para gerar</small>
        <b>{{quantidadePronta()}}</b>
      </span>
    </div>
  </div>

  <kendo-grid kendoGridSelectBy="idInsumo"
              [kendoGridBinding]="linhas"
              [selectable]="{mode: 'multiple', drag: false, checkboxOnly: true}"
              [(selectedKeys)]="idsSelecionados"
              [height]="430"
              class="gridProdutos grid-gerar-produtos">
    <kendo-grid-messages noRecords="Nenhum insumo encontrado neste grupo"></kendo-grid-messages>

    <kendo-grid-checkbox-column [width]="48">
      <ng-template kendoGridHeaderTemplate>
        <input type="checkbox"
               class="k-checkbox k-checkbox-md k-rounded-md"
               aria-label="Selecionar todos os insumos"
               [checked]="todasLinhasSelecionadas()"
               [indeterminate]="selecaoParcial()"
               [disabled]="gerando || !linhas.length"
               (change)="altereSelecaoTodasLinhas($event)">
      </ng-template>
      <ng-template kendoGridCellTemplate let-rowIndex="rowIndex" let-linha>
        <input type="checkbox"
               class="k-checkbox k-checkbox-md k-rounded-md"
               [kendoGridSelectionCheckbox]="rowIndex"
               [disabled]="gerando || linha.status === 'sucesso'">
      </ng-template>
    </kendo-grid-checkbox-column>

    <kendo-grid-column title="Insumo / ficha técnica" [width]="190">
      <ng-template kendoGridCellTemplate let-linha>
        <b>{{linha.insumo.nome}}</b>
        <span *ngIf="linha.insumo.objeto === 'ficha-tecnica'"
              class="badge badge-info d-block mt-1">Ficha de produto</span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column title="Vínculos produtos" [width]="125">
      <ng-template kendoGridCellTemplate let-linha>
        <span class="badge"
              [ngClass]="linha.totalVinculosProdutos > 0 ? 'badge-info' : 'badge-light'">
          {{linha.totalVinculosProdutos}}
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column title="Nome do produto" [width]="230">
      <ng-template kendoGridCellTemplate let-linha>
        <input kendoTextBox class="form-control" maxlength="160"
               [disabled]="gerando || linha.status === 'sucesso'"
               [(ngModel)]="linha.nome">
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column title="Código PDV" [width]="145">
      <ng-template kendoGridCellTemplate let-linha>
        <input kendoTextBox class="form-control"
               [disabled]="gerando || linha.status === 'sucesso'"
               [(ngModel)]="linha.codigoPdv">
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column title="Preço" [width]="145">
      <ng-template kendoGridCellTemplate let-linha>
        <kendo-numerictextbox class="preco-produto"
                              [min]="0"
                              [decimals]="2"
                              [format]="'c2'"
                              [disabled]="gerando || linha.status === 'sucesso'"
                              [(ngModel)]="linha.preco">
        </kendo-numerictextbox>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column title="Resultado" [width]="190">
      <ng-template kendoGridCellTemplate let-linha>
        <span *ngIf="linha.status === 'processando'" class="text-muted">
          <i class="k-icon k-i-loading mr-1"></i>Gerando...
        </span>
        <span *ngIf="linha.status === 'sucesso'" class="resultado-sucesso">
          <i class="fas fa-check-circle mr-1"></i>Gerado
        </span>
        <span *ngIf="linha.status === 'erro'" class="resultado-erro"
              kendoTooltip [title]="linha.erro">
          <i class="fas fa-times-circle mr-1"></i>{{linha.erro}}
        </span>
        <span *ngIf="!linha.status && !idsSelecionados.includes(linha.idInsumo)"
              class="resultado-status resultado-status--neutro">
          Não selecionado
        </span>
        <span *ngIf="!linha.status && idsSelecionados.includes(linha.idInsumo) && !linhaPronta(linha)"
              class="resultado-status resultado-status--pendente">
          <i class="fas fa-exclamation-circle mr-1"></i>Preencha os campos
        </span>
        <span *ngIf="!linha.status && idsSelecionados.includes(linha.idInsumo) && linhaPronta(linha)"
              class="resultado-status resultado-status--pronto">
          <i class="fas fa-check-circle mr-1"></i>Pronto para gerar
        </span>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>

<kendo-dialog-actions class="gerar-produtos-actions">
  <div class="resumo-rodape">
    <span class="resumo-rodape__icone"><i class="fas fa-check"></i></span>
    <b>{{quantidadeSelecionada()}} insumo(s) selecionado(s)</b>
    <span class="resumo-rodape__divisor"></span>
    <span class="text-muted">Preencha os campos para gerar os produtos.</span>
  </div>
  <div class="acoes-rodape">
    <button type="button" class="btn btn-light btn-fechar" [disabled]="gerando" (click)="feche()">
      Fechar
    </button>
    <button type="button" class="btn btn-gerar" [disabled]="!podeGerar()" (click)="gereProdutos()">
      <i class="k-icon k-i-loading mr-1" *ngIf="gerando"></i>
      <i class="fas fa-cube mr-2" *ngIf="!gerando"></i>
      {{gerando ? 'Gerando produtos...' : 'Gerar produtos'}}
    </button>
  </div>
</kendo-dialog-actions>
